var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({width: '98%', height: '280px'}),attrs:{"id":"lineChart"}})}
var staticRenderFns = []

export { render, staticRenderFns }